import { Component, EventEmitter, Input, Output } from '@angular/core';
import { addIcons } from 'ionicons';
import { ellipsisHorizontalOutline, searchOutline } from 'ionicons/icons';
import { LegalLink } from './app.types';

@Component({
  selector: 'app-legal-footer',
  standalone: false,
  template: `
    <section class="legal-footer" role="contentinfo" [class.legal-footer--expanded]="legalExpanded">
      <ion-buttons class="legal-footer__actions">
        <div class="legal-footer__collapsible">
          <ion-button
            *ngIf="canSubscribe"
            size="small"
            color="warning"
            type="button"
            (click)="openBilling.emit($event)"
          >
            Subscribe
          </ion-button>
          <ion-button
            size="small"
            color="tertiary"
            [href]="supportLinks.cve"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
            CVE Scanner
          </ion-button>
          <ion-button
            size="small"
            color="primary"
            [href]="supportLinks.feedback"
            target="_blank"
            rel="noopener noreferrer"
          >
            Feedback
          </ion-button>
          <ion-button
            size="small"
            color="success"
            [href]="supportLinks.googleGroup"
            target="_blank"
            rel="noopener noreferrer"
          >
            Join Google Group
          </ion-button>
          <ion-button size="small" fill="clear" (click)="openCookiePreferences.emit()">Cookie Preferences</ion-button>
        </div>

        <ion-button
          class="legal-footer__toggle"
          size="small"
          fill="clear"
          aria-controls="legal-footer-panel"
          [attr.aria-expanded]="legalExpanded"
          (click)="toggleLegal.emit()"
        >
          <ion-icon slot="start" name="ellipsis-horizontal-outline" aria-hidden="true"></ion-icon>
          More
        </ion-button>
      </ion-buttons>

      <ion-buttons class="legal-footer__panel" id="legal-footer-panel">
        <ion-button
          size="small"
          fill="clear"
          *ngFor="let link of legalLinks"
          [href]="'/' + link.slug + (link.fragment ? '#' + link.fragment : '')"
          (click)="openLegalPage.emit({ link, event: $event })"
        >
          {{ link.label }}
        </ion-button>
      </ion-buttons>
    </section>
  `
})
export class LegalFooterComponent {
  @Input({ required: true }) supportLinks!: Record<'cve' | 'feedback' | 'googleGroup', string>;
  @Input() legalLinks: LegalLink[] = [];
  @Input() legalExpanded = false;
  @Input() canSubscribe = false;

  @Output() openCookiePreferences = new EventEmitter<void>();
  @Output() openBilling = new EventEmitter<Event>();
  @Output() toggleLegal = new EventEmitter<void>();
  @Output() openLegalPage = new EventEmitter<{ link: LegalLink; event: Event }>();

  constructor() {
    addIcons({ ellipsisHorizontalOutline, searchOutline });
  }
}
